<template>
    <div class="flats-card-resize-elem">
        <div class="container">
            <div class="resize-img" v-if="resizeImg != null"><img :src="resizeImg" alt=""></div>
            <a href="#" class="close-link" @click.prevent="closeResizeElem"><svgIcon name="close" class="icon-svg"/></a>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'flats--card',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            resizeInit: 'loadFlatsResizeElemInit',
            resizeImg: 'loadFlatsResizeImg',
        }),
        methods: {
            closeResizeElem() {
                this.$store.commit('flatsResizeElemInit', false);
                this.$store.commit('flatsResizeImgSet', null);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('visibilityHide');
                document.getElementById('footer').classList.remove('visibilityHide');
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-page/flats-card-resize-elem.scss';
    // @import '@/styles/components/flats-page/respond/flats-page-respond.scss';
</style>